import Vue from "vue";
import Router from "vue-router";
import { setCookie, unsetCookie } from "@lib/util";
// import { readdirSync } from 'fs'

Vue.use(Router);

let routes = [];

// .*会被参数替换为前端构建时候的环境变量
try {
  let context = require.context(
    `./modules`,
    true,
    /(.*)\/routes\.js$/
  );
  context.keys().forEach(key => {
    // console.log(key)
    if (process.env.NODE_ENV != "production") {
      console.log(key);
    }
    var route = context(key).default;
    routes = routes.concat(route);
  });
} catch (err) {
  console.warn(err.message);
}

const router = new Router({
  routes
});

router.beforeEach((to, from, next) => {
  if (to.query.clear) {
    unsetCookie("token");
    localStorage.clear();
  }
  if (to.query.token) {
    setCookie("token", decodeURIComponent(to.query.token));
  }
  window.CLOSE_WINDOW_STATUS < 2 && (window.CLOSE_WINDOW_STATUS = 2);
  !window.PAGE_JS_TIME && (window.PAGE_JS_TIME = new Date().getTime());
  next();
});
router.beforeEach((to, from, next) => {
  if (to.meta.unsetTitle) {
    document.title = "";
    next();
    return;
  }
  let title = to.meta.title || "Python认知课";
  document.title = title;
  next();
});
router.afterEach(() => {
  setTimeout(() => {
    window.location.hash = window.location.hash.replace(/token=[^&]*&?/, "");
  }, 0);
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js